import React, { Component } from 'react';
import _ from 'lodash';
import { constSendMail } from '../../../../../utils/clientConstant';
import Image from '../../../../../components/ZUILib/Image';
import DownloadPdfHeader from '../../../../../components/DownloadPdfHeader';
import commonUtil from '../../../../../utils/commonUtil';

const defaultGiftImage = commonUtil.getAssetURL() + '/images/guest/gift.png';
const mesa_de_regalos_logo = commonUtil.getImageMeta().mesaDeRegalosLogo;

class StatementPrintAndDownload extends Component {
  render() {
    const { statementPrintAndDownload, eventDetailsInfo, accountStatus, isBonusContainerVisibleGL } = this.props;
    let isBonusContainerVisible = commonUtil.isBonusAvailable(this?.props?.eventDetailsInfo);

    if (isBonusContainerVisibleGL) {
      isBonusContainerVisible = isBonusContainerVisibleGL;
    }

    // Estimate total pages
    let totalPages = 1; // Start with 1 for the summary section
    const physicalItemCount = statementPrintAndDownload?.accountStatementInfo?.statementDetails?.physicalItemDetails?.length || 0;
    const personalItemCount = statementPrintAndDownload?.accountStatementInfo?.statementDetails?.personalItemDetails?.length || 0;
    const electronicItemCount = statementPrintAndDownload?.accountStatementInfo?.statementDetails?.electronicItemDetails?.length || 0;
    const transferenceCount = statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceDetails?.length || 0;

    // Add pages for each section with content
    // if (physicalItemCount > 0) totalPages += 1 + Math.ceil((physicalItemCount - 1) / 8); // 1 for header, plus pages for every 8 items
    // if (physicalItemCount > 0) totalPages += (physicalItemCount === 1) ? 1 : Math.ceil((physicalItemCount - 1) / 8); 
    totalPages += (physicalItemCount === 0 || physicalItemCount === 1) ? 1 : Math.ceil((physicalItemCount) / 8); // plus pages for every 8 items
    totalPages += (personalItemCount === 0 || personalItemCount === 1) ? 1 : Math.ceil((personalItemCount) / 8); // Personal purchases section, updated for pagination
    totalPages += (electronicItemCount === 0 || electronicItemCount === 1) ? 1 : Math.ceil((electronicItemCount) / 8); // Electronic gifts section
    totalPages += (transferenceCount <= 6) ? 1 : 1 + Math.ceil((transferenceCount - 6) / 10);// Withdrawals section, updated to 10 items per page
    // totalPages += 1; // Transference (assumes 1 page, may need adjustment if content is extensive)
    totalPages += 1; // Bonus section (assumes 1 page, may need adjustment if content is extensive)

    let currentPage = 1;

    const formatStatementPdfDate = (dateString) => {
      if (!dateString) return '';
      const datePart = dateString.split(' ')[0];
      const [year, month, day] = datePart.split('-');
      return `${day}/${month}/${year}`;
    };

    const maskAccountNumber = (n) => {
      return n ? n.replace(/\d(?=\d{4})/g, 'x') : '';
    };

    const getBrandLogoPath = () => {
      const brand = commonUtil.getBrand();
      let path = '';
      switch (brand) {
        case 'LP':
          path = commonUtil.getAssetURL() + '/images/liverpool_logo.png';
          break;
        case 'PB':
          path = commonUtil.getAssetURL() + '/images/logos/logo-pb.png';
          break;
        case 'PBK':
          path = commonUtil.getAssetURL() + '/images/logos/logo-pbk.png';
          break;
        case 'GAP':
          path = commonUtil.getAssetURL() + '/images/logoGap.png';
          break;
        case 'WLM':
          path = commonUtil.getAssetURL() + '/images/logos/logo-we.png';
          break;
        case 'WS':
          path = commonUtil.getAssetURL() + '/images/logos/logo-ws.png';
          break;
        case 'TRU':
          path = commonUtil.getAssetURL() + '/images/logo-toys.png';
          break;
        default:
          break;
      }
      return path;
    };

    const physicalGiftRow = (data, index) => {
      const imageAttr = {
        id: 'physicalGiftRowImage' + index,
        src: data?.image,
        alt: data?.productName,
        altImg: defaultGiftImage,
      };

      const shouldInsertPageBreak = index !== 0 && index % 8 === 0;

      return (
        <React.Fragment key={index}>
          {shouldInsertPageBreak && (
            <>
              <tr className="bordernone" style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
                <td colSpan="6">
                  <br />
                  Página {currentPage++} de {totalPages}
                </td>
              </tr>
              <br /> <br />
              <span className="dummyPageBreak dummyPageBreakNoHeader" />
              <tr className="bordernone">
                <td colSpan="6" style={{ padding: 0 }}>
                  <div className="row pdfclass">
                    <div className="col-xs-6 col-sm-6 pdf-header-imgs">
                      <img src={commonUtil.getBrandLogoPathforPDF()} className="brand-img-logo" />
                      <img className="pdf-mesalogo" src={mesa_de_regalos_logo} />
                    </div>
                    {/* <div className="col-xs-6 col-sm-6 text-right mt-15">
                    </div> */}
                  </div>
                </td>
              </tr>
              <br /> <br />
              <tr className="borderStatementTableHeader" style={{ maxHeight: '81px', height: '81px' }}>
                <td className="borderStatementTable textcenter"><b>Regalos físicos</b></td>
                <td className="borderStatementTable textRight">
                  <b>Número de regalos </b>
                  <br />
                  {statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalPurchasedItemsCount}
                </td>
                <td className="borderStatementTable textRight" colSpan={isBonusContainerVisible ? undefined : 4}>
                  <b>Monto total de regalos </b>
                  <br />
                  {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalPurchasedAmount)}
                </td>
                {isBonusContainerVisible ? (
                  <>
                    <td className="borderStatementTable textRight" colSpan="2">
                      <b>Monto válido para bono </b>
                      <br />
                      {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalAmountEligibleForBonus)}
                      <br />
                      <span className="monto-no-validado">
                        Monto no válido para bono: {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalAmountNotEligibleForBonus)}
                      </span>
                    </td>
                    <td className="borderStatementTable textRight" colSpan="1">
                      <b>Bono por regalos físicos</b>
                      <br />
                      {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalBonusAmount)}
                    </td>
                  </>
                ) : null}
              </tr>
              <br /> <br />
              <br /> <br />
              <tr style={{ maxHeight: '35px' }} className="page-break-row">
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Fecha</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Artículo</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Precio</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Cantidad</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Tienda</b></a></td>
                {/* {isBonusContainerVisible ? ( */}
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Aplica para bono</b></a></td>
                {/* ) : <td className="borderStatementTable" ></td>} */}
              </tr>
            </>
          )}

          <tr className="divTR" style={{ minHeight: '101px', maxHeight: '101px', height: '101px' }}>
            <td className="borderStatementTableBottom" >
              <p>{formatStatementPdfDate(data?.date)}</p>
            </td>
            <td className="imgInner borderStatementTableBottom" >
              <div className="col-xs-3">
                <Image imageAttr={imageAttr} />
              </div>
              <div className="col-xs-9">
                <p>
                  {data?.productName} <br />
                  <span className="sku">SKU: {data?.skuId}</span>
                  {data?.purchaserName && (
                    <>
                      <br />
                      <span className="sku">Invitado: {data?.purchaserName}</span>
                    </>
                  )}
                </p>
              </div>
            </td>
            <td className="borderStatementTableBottom" >
              <p className="text-center">{commonUtil.getCurrency(data?.amount)}</p>
            </td>
            <td className="borderStatementTableBottom" >
              <p className="text-center">{data?.quantity}</p>
            </td>
            <td className="borderStatementTableBottom" >
              <p className="text-center">{data?.brand}</p>
            </td>
            <td className="borderStatementTableBottom textcenter" >
              {/* {isBonusContainerVisible && (
                <> */}
              {data?.bonusEligibility === true ? (
                <img src={`${commonUtil.getAssetURL() + '/images/icons/giftlist/green_check.svg'}`} style={{ width: '20px', height: '20px' }} />
              ) : (
                <p>
                  <div className='bono-text'>
                    <span>X</span>
                  </div>
                  <p className="devolucion">{data?.bonusStatus}</p>
                </p>
              )}
              {/* </>
              )} */}
            </td>
          </tr>
        </React.Fragment>
      );
    };

    const partialTransferDetails = (data, index) => {
      const shouldInsertPageBreak = index !== 0 && ((index <= 6 && index % 6 === 0) || (index > 6 && (index - 6) % 10 === 0)); // Standardized to 6 items per page for first page and 10 for remaing pages
      return (
        <React.Fragment key={index}>
          {shouldInsertPageBreak && (
            <>
              <tr className="bordernone" style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
                <td colSpan="6" style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt', color: '#333' }}>
                  <br />
                  Página {currentPage++} de {totalPages}
                </td>
              </tr>
              <br /> <br />
              <br /> <br />
              <br /> <br />
              <span className="dummyPageBreak dummyPageBreakNoHeader" />
              <tr className="bordernone">
                <td colSpan="6" style={{ padding: 0 }}>
                  <div className="row pdfclass">
                    <div className="col-xs-6 col-sm-6 pdf-header-imgs">
                      <img src={commonUtil.getBrandLogoPathforPDF()} className="brand-img-logo" />
                      <img className="pdf-mesalogo" src={mesa_de_regalos_logo} />
                    </div>
                  </div>
                </td>
              </tr>
              <br /> <br />
              <tr className="borderStatementTableHeader" style={{ maxHeight: '81px', height: '81px' }}>
                <td className="borderStatementTable textcenter"><b>Transferencias</b></td>
                <td className="borderStatementTable textRight" >
                  <b>Número de transferencias </b>
                  <br />
                  {statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceSummary?.totalCountOfTransactions}
                </td>
                <td className="borderStatementTable textRight" colSpan="4">
                  <b>Monto total transferido </b>
                  <br />
                  {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceSummary?.totalTransferredAmount)}
                </td>
              </tr>
              <br /> <br />
              <br /> <br />
              <tr style={{ maxHeight: '35px' }} className="page-break-row">
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Fecha</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Tienda</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Usuario</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Método de transferencia</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Comisión</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Monto transferido</b></a></td>
              </tr>
            </>
          )}

          <tr className="divTR" style={{ minHeight: '81px', maxHeight: '81px', height: '81px' }}>
            <td className="borderStatementTableBottom text-center" >
              <p>{data?.date}</p>
            </td>
            <td className="borderStatementTableBottom text-center" >
              <p>{data?.storeName}</p>
            </td>
            <td className="borderStatementTableBottom text-center" >
              <p className="text-center">{data?.userName}</p>
            </td>
            <td className="borderStatementTableBottom text-center" >
              <p className="text-center">{data?.transferenceMethod} <br /> {data?.accountNumber ? maskAccountNumber(data?.accountNumber) : ''}</p>
            </td>
            <td className="borderStatementTableBottom text-center" >
              <p>{data?.commission ? commonUtil.getCurrency(data?.commission) : '.00'}</p>
            </td>
            <td className="borderStatementTableBottom text-center" >
              <p>{commonUtil.getCurrency(data?.amountTransferred)}</p>
            </td>
          </tr>
        </React.Fragment>
      );
    };

    const electronicsDetail = (data, index) => {
      const imageAttr = {
        id: 'electronicsDetail' + index,
        src: data?.image,
        alt: data?.productName,
        altImg: defaultGiftImage,
      };

      const shouldInsertPageBreak = index !== 0 && index % 8 === 0;

      return (
        <React.Fragment key={index}>
          {shouldInsertPageBreak && (
            <>
              <tr className="bordernone" style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
                <td colSpan="5">
                  <br />
                  Página {currentPage++} de {totalPages}
                </td>
              </tr>
              <br /> <br />
              <span className="dummyPageBreak dummyPageBreakNoHeader" />
              <tr className="bordernone">
                <td colSpan="5" style={{ padding: 0 }}>
                  <div className="row pdfclass">
                    <div className="col-xs-6 col-sm-6 pdf-header-imgs">
                      <img src={commonUtil.getBrandLogoPathforPDF()} className="brand-img-logo" />
                      <img className="pdf-mesalogo" src={mesa_de_regalos_logo} />
                    </div>
                  </div>
                </td>
              </tr>
              <br /> <br />
              <tr className="borderStatementTableHeader" style={{ maxHeight: '81px', height: '81px', minHeight: '81px' }}>
                <td className="borderStatementTable textcenter"><b>Regalos electrónicos</b></td>
                <td className="borderStatementTable textRight">
                  <b>Número de regalos </b>
                  <br />
                  {statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalPurchasedItemsCount}
                </td>
                <td className="borderStatementTable textRight">
                  <b>Monto total de regalos </b>
                  <br />
                  {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalPurchasedAmount)}
                </td>
                <td className="borderStatementTable textRight">
                  <b>Retiros anticipados </b>
                  <br />
                  -{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.transferredAmount)}
                </td>
                <td className="borderStatementTable textRight">
                  <b>Disponible para retiro </b>
                  <br />
                  {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalAmount)}
                </td>
              </tr>
              <br /> <br />
              <br /> <br />
              <tr style={{ maxHeight: '35px' }} className="page-break-row">
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Fecha</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Artículo</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Cantidad</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Tienda</b></a></td>
                <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Precio</b></a></td>
              </tr>
            </>
          )}
          <tr className="divTR" style={{ minHeight: '101px', maxHeight: '101px', height: '101px' }}>
            <td className="borderStatementTableBottom" >
              <p>{formatStatementPdfDate(data?.date)}</p>
            </td>
            <td className="imgInner borderStatementTableBottom" >
              <div className="col-xs-3">
                <Image style={{ height: '60px' }} imageAttr={imageAttr} />
              </div>
              <div className="col-xs-9">
                <p>
                  {data?.productName} <br />
                  <span className="sku">SKU: {data?.skuId}</span>
                  {data?.purchaserName ? (
                    <>
                      <br />
                      {/* <span className="sku">Invitado: <s>{data?.purchaserName}</s></span> */}
                      <span className="sku">Invitado: {data?.purchaserName}</span>
                    </>
                  ) : null}
                </p>
              </div>
            </td>
            <td className="borderStatementTableBottom" >
              <p className="text-center">{data?.quantity}</p>
            </td>
            <td className="borderStatementTableBottom" >
              <p className="text-center">{data?.brand}</p>
            </td>
            <td className="borderStatementTableBottom" >
              <p className="text-center">{commonUtil.getCurrency(data?.amount)}</p>
            </td>
          </tr>
        </React.Fragment>
      );
    };

    const downloadContainer = (
      <div className="container">
        {/* Summary Section */}
        <div className="row info">
          <div className="col-xs-9">
            <h4>
              <p><b>Estado de cuenta</b></p>
            </h4>
            <br />
            <p>
              <label className="date_operation">Fecha de operación</label>{' '}
              <span>
                <b>{accountStatus?.currTime ? new Date().toLocaleDateString('en-GB') : ''}</b>
              </span>
            </p>
          </div>
          <div className="col-xs-3 event">
            <p>
              <span className='colorTextBlack'>Número de evento: </span>
              {eventDetailsInfo?.eventId}
            </p>
            <br />
            <p>
              <span className='colorTextBlack'>Tipo de evento: </span>
              {eventDetailsInfo?.eventType}
            </p>
            <br />
            <p>
              <span className='colorTextBlack'>Fecha del evento:</span>
              {formatStatementPdfDate(eventDetailsInfo?.eventDate)}
            </p>
          </div>
        </div>
        <div className="row margin_top border-bottom">
          <div className="col-xs-6">
            <p><b>Total de regalos y compras personales</b></p>
          </div>
          <div className="col-xs-1">
            <p>{+statementPrintAndDownload?.accountStatementInfo?.statementSummary?.totalPurchasedItems}</p>
          </div>
          <div className="col-xs-3">
            <p>&nbsp;</p>
          </div>
          <div className="col-xs-2">
            <p>{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.totalPurchasedAmount)}</p>
          </div>
        </div>
        <div className="row margin_top border-bottom">
          <div className="col-xs-6">
            <p>Regalos físicos</p>
          </div>
          <div className="col-xs-1">
            <p>{statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalPurchasedItemsCount}</p>
          </div>
          <div className="col-xs-3">
            <p>&nbsp;</p>
          </div>
          <div className="col-xs-2">
            <p>{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalPurchasedAmount)}</p>
          </div>
        </div>
        <div className="row margin_top border-bottom">
          <div className="col-xs-6">
            <p>Compras personales</p>
          </div>
          <div className="col-xs-1">
            <p>{statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalPurchasedItemsCount}</p>
          </div>
          <div className="col-xs-3">
            <p>&nbsp;</p>
          </div>
          <div className="col-xs-2">
            <p>{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalPurchasedAmount)}</p>
          </div>
        </div>
        <div className="row margin_top border-bottom">
          <div className="col-xs-6">
            <p>Regalos Electrónicos</p>
          </div>
          <div className="col-xs-1">
            <p>{statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalPurchasedItemsCount}</p>
          </div>
          <div className="col-xs-3">
            <p>Retiros anticipados: -{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.transferredAmount)}</p>
          </div>
          <div className="col-xs-2">
            <p>{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalPurchasedAmount)}</p>
          </div>
        </div>
        <div className="row margin_top">
          <div className="col-xs-12 table-title">
            <p>Detalle</p>
          </div>
          <div className="bodytable col-xs-12">
            <table className="pdftableWithoutAlign">
              <tbody className="rowLines">
                <tr className="" style={{ maxHeight: '81px', height: '81px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                  <td className="borderStatementTable textcenter">Regalos físicos</td>
                  <td colSpan={isBonusContainerVisible ? '' : '2'} className="borderStatementTable textRight" >
                    Número de regalos<br />
                    {statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalPurchasedItemsCount}
                  </td>
                  <td colSpan={isBonusContainerVisible ? '' : '2'} className="borderStatementTable textRight" >
                    Monto total de regalos<br />
                    {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalPurchasedAmount)}
                  </td>
                  {isBonusContainerVisible ? (
                    <>
                      <td className="borderStatementTable textRight">
                        Monto válido para bono<br />
                        {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalAmountEligibleForBonus)}
                        <br />
                        <span className="monto-no-validado">
                          Monto no válido para bono: {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalAmountNotEligibleForBonus ?? '')}
                        </span>
                      </td>
                      <td className="borderStatementTable textRight">
                        Bono por regalos físicos<br />
                        {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalBonusAmount)}
                      </td>
                    </>
                  ) : null}
                </tr>
                <tr className="" style={{ maxHeight: '81px', height: '81px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                  <td className="borderStatementTable textcenter">Compras personales</td>
                  <td colSpan={isBonusContainerVisible ? '' : '2'} className="borderStatementTable textRight" >
                    Número de compras <br />
                    {statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalPurchasedItemsCount}
                  </td>
                  <td colSpan={isBonusContainerVisible ? '' : '2'} className="borderStatementTable textRight" >
                    Monto total de compras<br />
                    {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalPurchasedAmount)}
                  </td>
                  {isBonusContainerVisible ? (
                    <>
                      <td className="borderStatementTable textRight" >
                        Monto válido para bono<br />
                        {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalAmountEligibleForBonus)}
                        <br />
                        <span className="monto-no-validado">
                          Monto no válido para bono: {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalAmountNotEligibleForBonus ?? '')}
                        </span>
                      </td>
                      <td className="borderStatementTable textRight" >
                        Bono por compras personales<br />
                        {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalBonusAmount)}
                      </td>
                    </>
                  ) : null}
                </tr>
                <tr className="" style={{ maxHeight: '81px', height: '81px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                  <td className="borderStatementTable textcenter">Regalos electrónicos</td>
                  <td className="borderStatementTable textRight" >
                    Número de regalos<br />
                    {statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalPurchasedItemsCount}
                  </td>
                  <td className="borderStatementTable textRight" >
                    Monto total de regalos<br />
                    {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalPurchasedAmount)}
                  </td>
                  <td className="borderStatementTable textRight" >
                    Retiros anticipados<br />
                    -{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.transferredAmount)}
                  </td>
                  <td className="borderStatementTable textRight" >
                    Disponible para retiro<br />
                    {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalAmount)}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="row emptyTableRowHeightFirstPage">
            <div className="col-xs-12"></div>
          </div>
        </div>
        <div style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
          Página {currentPage++} de {totalPages}
        </div>
        <span className="dummyPageBreak" />
        {/* Physical Gifts Section */}
        {statementPrintAndDownload?.accountStatementInfo?.statementDetails?.physicalItemDetails && (
          <>
            <div className="row margin_top">
              <h3><b>Regalos físicos</b></h3>
              <div className="bodytable col-xs-12">
                <table className="pdftableWithoutAlign">
                  <tbody className="rowLines">
                    <tr className="" style={{ maxHeight: '81px', height: '81px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                      <td className="borderStatementTable textcenter"><b>Regalos físicos</b></td>
                      <td className="borderStatementTable textRight" >
                        <b>Número de regalos </b>
                        <br />
                        {statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalPurchasedItemsCount}
                      </td>
                      <td className="borderStatementTable textRight" >
                        <b>Monto total de regalos </b>
                        <br />
                        {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalPurchasedAmount)}
                      </td>
                      {isBonusContainerVisible ? (
                        <>
                          <td className="borderStatementTable textRight" >
                            <b>Monto válido para bono </b>
                            <br />
                            {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalAmountEligibleForBonus)}
                            <br />
                            <span className="monto-no-validado">
                              Monto no válido para bono: {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalAmountNotEligibleForBonus)}
                            </span>
                          </td>
                          <td className="borderStatementTable textRight" >
                            <b>Bono por regalos físicos</b>
                            <br />
                            {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.physicalItemInfo?.totalBonusAmount)}
                          </td>
                        </>
                      ) : null}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="contentTable">
                <table className="tableResultsStatement">
                  {!_.isEmpty(statementPrintAndDownload?.accountStatementInfo?.statementDetails?.physicalItemDetails) ?
                    <thead className="rowLines">
                      <tr style={{ maxHeight: '35px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Fecha</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Artículo</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Precio</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Cantidad</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Tienda</b></a></td>
                        {/* {isBonusContainerVisible ? ( */}
                          <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Aplica para bono</b></a></td>
                         {/* ) : null} */}
                      </tr>
                    </thead>
                    : null}
                  <tbody>
                    {statementPrintAndDownload?.accountStatementInfo?.statementDetails?.physicalItemDetails?.map(physicalGiftRow)}
                    {/* Add filler rows if less than 8 on the last page */}
                    {(() => {
                      const physicalItemDetails =
                        statementPrintAndDownload?.accountStatementInfo?.statementDetails?.physicalItemDetails || [];
                      const remainder = physicalItemDetails.length % 8;

                      if (remainder > 0) {
                        const emptyRows = 8 - remainder;

                        return Array.from({ length: emptyRows }).map((_, i) => (
                          <tr key={`physical-empty-${i}`} className='emptyTableRowHeightPhysical'>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            {isBonusContainerVisible ? (
                              <td>&nbsp;</td>
                            ) : null}
                          </tr>
                        ));
                      } else if (physicalItemDetails.length === 0) {
                        return <>
                          {Array.from({ length: 8 }).map((_, i) => (
                            <tr key={`physical-empty-${i}`} className='emptyTableRowHeightPhysical'>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              {isBonusContainerVisible ? (
                                <td>&nbsp;</td>
                              ) : null}
                            </tr>
                          ))}
                          <tr className='emptyHeaderRowHeight'></tr>
                        </>
                      }
                      return null;
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
              Página {currentPage++} de {totalPages}
            </div>
            <span className="dummyPageBreak" />
          </>
        )}
        {/* Personal Purchases Section */}
        {statementPrintAndDownload?.accountStatementInfo?.statementDetails?.personalItemDetails && (
          <>
            <div className="row margin_top">
              <h3><b>Compras personales</b></h3>
              <div className="bodytable col-xs-12">
                <table className="pdftableWithoutAlign">
                  <tbody className="rowLines">
                    <tr className="" style={{ maxHeight: '81px', height: '81px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                      <td className="borderStatementTable textcenter"><b>Compras personales</b></td>
                      <td className="borderStatementTable textRight" >
                        <b>Número de compras </b>
                        <br />
                        {statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalPurchasedItemsCount}
                      </td>
                      <td className="borderStatementTable textRight" >
                        <b>Monto total de compras </b>
                        <br />
                        {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalPurchasedAmount)}
                      </td>
                      {isBonusContainerVisible ? (
                        <>
                          <td className="borderStatementTable textRight" >
                            <b>Monto válido para bono </b>
                            <br />
                            {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalAmountEligibleForBonus)}
                            <br />
                            <span className="monto-no-validado">
                              Monto no válido para bono: {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalAmountNotEligibleForBonus)}
                            </span>
                          </td>
                          <td className="borderStatementTable textRight" >
                            <b>Bono por compras personales </b>
                            <br />
                            {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.personalItemInfo?.totalBonusAmount)}
                          </td>
                        </>
                      ) : null}
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 contentTable">
                <table className="tableResultsStatement">
                  {!_.isEmpty(statementPrintAndDownload?.accountStatementInfo?.statementDetails?.personalItemDetails) ? (
                    <thead className="rowLines">
                      <tr style={{ maxHeight: '35px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Fecha</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Artículo</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Precio</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Cantidad</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Tienda</b></a></td>
                        {/* {isBonusContainerVisible ? ( */}
                          <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Aplica para bono</b></a></td>
                        {/* ) : null} */}
                      </tr>
                    </thead>
                  ) : null}
                  <tbody>
                    {statementPrintAndDownload?.accountStatementInfo?.statementDetails?.personalItemDetails.map(physicalGiftRow)}
                    {/* Add filler rows if less than 8 on the last page */}
                    {(() => {
                      const personalItemDetails =
                        statementPrintAndDownload?.accountStatementInfo?.statementDetails?.personalItemDetails || [];
                      const remainder = personalItemDetails.length % 8;

                      if (remainder > 0) {
                        const emptyRows = 8 - remainder;

                        return Array.from({ length: emptyRows }).map((_, i) => (
                          <tr key={`personal-empty-${i}`} className='emptyTableRowHeightPhysical'>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            {isBonusContainerVisible ? (
                              <td>&nbsp;</td>
                            ) : null}
                          </tr>
                        ));
                      } else if (personalItemDetails.length === 0) {
                        return <>
                          {Array.from({ length: 8 }).map((_, i) => (
                            <tr key={`personal-empty-${i}`} className='emptyTableRowHeightPhysical'>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              {isBonusContainerVisible ? (
                                <td>&nbsp;</td>
                              ) : null}
                            </tr>
                          ))}
                          <tr className='emptyHeaderRowHeight'></tr>
                        </>
                      }
                      return null;
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
              Página {currentPage++} de {totalPages}
            </div>
            <span className="dummyPageBreak" />
          </>
        )}
        {/* Electronic Gifts Section */}
        {statementPrintAndDownload?.accountStatementInfo?.statementDetails?.electronicItemDetails && (
          <>
            <div className="row margin_top">
              <h3><b>Regalos electrónicos</b></h3>
              <div className="bodytable col-xs-12">
                <table className="pdftableWithoutAlign">
                  <tbody className="rowLines">
                    <tr className="" style={{ maxHeight: '81px', height: '81px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                      <td className="borderStatementTable textcenter"><b>Regalos electrónicos</b></td>
                      <td className="borderStatementTable textRight">
                        <b>Número de regalos </b>
                        <br />
                        {statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalPurchasedItemsCount}
                      </td>
                      <td className="borderStatementTable textRight">
                        <b>Monto total de regalos </b>
                        <br />
                        {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalPurchasedAmount)}
                      </td>
                      <td className="borderStatementTable textRight">
                        <b>Retiros anticipados </b>
                        <br />
                        -{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.transferredAmount)}
                      </td>
                      <td className="borderStatementTable textRight">
                        <b>Disponible para retiro </b>
                        <br />
                        {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.statementSummary?.electronicItemInfo?.totalAmount)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="row">
              <div className="col-xs-12 contentTable">
                <table className="tableResultsStatement">
                  {!_.isEmpty(statementPrintAndDownload?.accountStatementInfo?.statementDetails?.electronicItemDetails) ? (
                    <thead className="rowLines">
                      <tr style={{ maxHeight: '35px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Fecha</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Artículo</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Cantidad</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Tienda</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Precio</b></a></td>
                      </tr>
                    </thead>
                  ) : null}
                  <tbody>
                    {statementPrintAndDownload?.accountStatementInfo?.statementDetails?.electronicItemDetails.map(electronicsDetail)}
                    {/* Add filler rows if less than 8 on the last page */}
                    {(() => {
                      const electronicItemDetails =
                        statementPrintAndDownload?.accountStatementInfo?.statementDetails?.electronicItemDetails || [];
                      const remainder = electronicItemDetails.length % 8;

                      if (remainder > 0) {
                        const emptyRows = 8 - remainder;
                        return Array.from({ length: emptyRows }).map((_, i) => (
                          <tr key={`empty-${i}`} className='emptyTableRowHeightPhysical'>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                          </tr>
                        ));
                      } else if (electronicItemDetails.length === 0) {
                        return Array.from({ length: 10 }).map((_, i) => (
                          <tr key={`empty-${i}`} className='emptyTableRowHeight'>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                            <td>&nbsp;</td>
                          </tr>
                        ));
                      }
                      return null;
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
              Página {currentPage++} de {totalPages}
            </div>
            <span className="dummyPageBreak" />
          </>
        )}
        {/* Withdrawals Section */}
        {statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceDetails && (
          <>
            <div className="row margin_top border-bottom">
              <h3><b>Retiros anticipados</b></h3>
            </div>
            <div className="row margin_top border-bottom">
              <b>
                <div className="col-xs-6">
                  <p>Retiros monedero</p>
                </div>
                <div className="col-xs-6 text-right">
                  <p>{statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceSummary?.totalTransactionToMonedero}</p>
                </div>
              </b>
            </div>
            <div className="row margin_top border-bottom">
              <b>
                <div className="col-xs-6">
                  <p>Retiros a cuenta bancaria</p>
                </div>
                <div className="col-xs-6 text-right">
                  <p>{statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceSummary?.totalTransactionsToBank}</p>
                </div>
              </b>
            </div>
            <div className="row margin_top border-bottom">
              <div className="col-xs-6">
                <p><b>Retiros anticipados</b></p>
              </div>
              <div className="col-xs-6 text-right">
                <p>-{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceSummary?.totalTransferredAmount)}</p>
              </div>
            </div>
            <div className="row margin_top">
              <div className="col-xs-12 contentTable">
                <table className="tableResultsStatement">
                  {!_.isEmpty(statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceDetails) ? (
                    <thead className="rowLines">
                      <tr className="borderStatementTableHeader" style={{ maxHeight: '81px', height: '81px' }}>
                        <td className="borderStatementTable textcenter"><b>Transferencias</b></td>
                        <td className="borderStatementTable textRight" >
                          <b>Número de transferencias </b>
                          <br />
                          {statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceSummary?.totalCountOfTransactions}
                        </td>
                        <td className="borderStatementTable textRight" colSpan="4">
                          <b>Monto total transferido </b>
                          <br />
                          {commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceSummary?.totalTransferredAmount)}
                        </td>
                      </tr>
                      <br /><br />
                      <tr className="" style={{ maxHeight: '35px', borderTop: '1px solid #9a9191ff', borderBottom: '1px solid #9a9191ff' }}>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Fecha</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Tienda</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Usuario</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Destino</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Comisión</b></a></td>
                        <td className="text-center borderStatementTable" ><a href="javascript:void(0);"><b>Monto</b></a></td>
                      </tr>
                    </thead>
                  ) : null}
                  <tbody>
                    {statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceDetails
                      ? statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceDetails.map(partialTransferDetails)
                      : null}

                    {/* Add filler rows if less than 6 on the last page */}
                    {(() => {
                      const transferenceDetails =
                        statementPrintAndDownload?.accountStatementInfo?.transferenceInfo?.transferenceDetails || [];
                      const remainder = transferenceDetails.length % 6;
                      const remainderForLastPage = (transferenceDetails.length - 6) % 10;

                      if (remainder > 0 && transferenceDetails.length <= 6) {
                        const emptyRows = 6 - remainder;
                        return <>
                          {Array.from({ length: emptyRows }).map((_, i) => (
                            <tr key={`transference-empty-${i}`} className='emptyTableRowHeight'>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                          ))}
                          <tr className='emptyTferenceSectionHeightForLessThanSix'></tr>
                        </>
                      }
                      else if (remainderForLastPage > 0 && transferenceDetails.length > 6) {
                        const emptyRows = 10 - remainderForLastPage;
                        return <>
                          {Array.from({ length: emptyRows }).map((_, i) => (
                            <tr key={`transference-empty-${i}`} className='emptyTableRowHeight'>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                          ))}
                          {/* <tr className='emptyTferenceSectionHeightForMoreThanSix'></tr> */}
                        </>
                      }
                      else if (remainder === 0 && transferenceDetails.length > 6) {
                        return (
                          <tr className="bordernone emptyTferenceSectionHeight">
                            <td colSpan="6">&nbsp;</td>
                          </tr>
                        )
                      }
                      else if (transferenceDetails.length === 0) {
                        return <>
                          {Array.from({ length: 8 }).map((_, i) => (
                            <tr key={`transference-empty-${i}`} className='emptyTableRowHeight'>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                              <td>&nbsp;</td>
                            </tr>
                          ))}
                          <tr className='emptyHeaderRowHeight'></tr>
                        </>
                      }
                      return null;
                    })()}
                  </tbody>
                </table>
              </div>
            </div>
            <div style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
              Página {currentPage++} de {totalPages}
            </div>
            <span className="dummyPageBreak" />
          </>
        )}
        {/* Bonus Section */}
        <div className="row info margin_top border-bottom">
          <div className="col-xs-12">
            <h4>
              <p><b>Aproximado de bono a monedero</b></p>
            </h4>
            <br />
            <p>
              <label className="date_operation">
                {+statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.bonusPercentage}% por compras personales y regalos válidos para bonificación.
              </label>
            </p>
            <br />
            <p>
              <label className="date_operation">El bono estará disponible hasta el cierre de su mesa.</label>
            </p>
          </div>
        </div>
        <div className="row sectionRetiroHeight">
          <div className="col-xs-12">
            <h4>
              <p><b>Regalos físicos:</b></p>
            </h4>
          </div>
          <div className="col-xs-12">
            <p>
              <b>
                Monto válido: <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.physicalItemsBonusInfo?.totalBonusEligibleAmount)}</span>
              </b>
            </p>
          </div>
          <div className="col-xs-12">
            <p>
              <label className="date_operation">Monto no válido:</label>{' '}
              <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.physicalItemsBonusInfo?.totalAmountNotEligibleForBonus)}</span>
            </p>
          </div>
          <div className="col-xs-12 table-title">
            <p>
              {+statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.bonusPercentage}% de bono por regalos físicos{' '}
              <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.physicalItemsBonusInfo?.totalBonusAccumulated)}</span>
            </p>
          </div>
        </div>
        <div className="row sectionRetiroHeight">
          <div className="col-xs-12">
            <h4>
              <p><b>Compras personales:</b></p>
            </h4>
          </div>
          <div className="col-xs-12">
            <p>
              <b>
                Monto válido: <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.personalItemsBonusInfo?.totalBonusEligibleAmount)}</span>
              </b>
            </p>
          </div>
          <div className="col-xs-12">
            <p>
              <label className="date_operation">Monto no válido:</label>{' '}
              <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.personalItemsBonusInfo?.totalAmountNotEligibleForBonus)}</span>
            </p>
          </div>
          <div className="col-xs-12 table-title">
            <p>
              {+statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.bonusPercentage}% de bono por compras personales{' '}
              <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.personalItemsBonusInfo?.totalBonusAccumulated)}</span>
            </p>
          </div>
        </div>
        <div className="row sectionRetiroHeight">
          <div className="col-xs-12">
            <h4>
              <p>
                <b>Regalos Electrónicos: <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.electronicItemsBonusInfo?.totalBonusEligibleAmount)}</span></b>
              </p>
            </h4>
          </div>
          <div className="col-xs-12">
            <p>Bono disponible al cierre de tu mesa si elijes depósito a monedero</p>
          </div>
          <div className="col-xs-12 table-title">
            <p>
              {+statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.bonusPercentage}% de bono por regalos electrónicos{' '}
              <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.electronicItemsBonusInfo?.totalBonusAccumulated)}</span>
            </p>
          </div>
        </div>
        <div className="row sectionRetiroHeight">
          <div className="col-xs-12">
            <h4>
              <p>
                <b>Monto total válido para bono:</b>{' '}
                <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.totalBonusEligibleAmount)}</span>
              </p>
            </h4>
          </div>
          <div className="col-xs-12 table-title">
            <p>
              Aproximado de bono total para monedero:{' '}
              <span className="pull-right">{commonUtil.getCurrency(statementPrintAndDownload?.accountStatementInfo?.bonusDetails?.totalBonusAmount)}</span>
            </p>
          </div>
        </div>
        <div className="row margin_top emptyTableRowHeightLastPage">
          <div className="col-xs-12"></div>
        </div>
        <div style={{ textAlign: 'right', marginTop: '10px', fontSize: '12pt' }}>
          Página {currentPage++} de {totalPages}
        </div>
      </div>
    );

    return (
      <div>
        {!_.isEmpty(statementPrintAndDownload) && !_.isEmpty(statementPrintAndDownload?.accountStatementInfo) && !_.isEmpty(eventDetailsInfo) ? (
          <React.Fragment>
            {this?.props?.type === constSendMail ? (
              <DownloadPdfHeader>{downloadContainer}</DownloadPdfHeader>
            ) : (
              <div className="toPrint">{downloadContainer}</div>
            )}
          </React.Fragment>
        ) : null}
      </div>
    );
  }
}

export default StatementPrintAndDownload;
